export const TABLE_ROW_HEIGHT = 85;
// Skeleton rows need to match the final rendered height; auto-row estimates stay 1px lower.
export const TABLE_ROW_MEASURE_HEIGHT = TABLE_ROW_HEIGHT - 1;
export const TABLE_PANEL_HEADER_HEIGHT = 48;
export const TABLE_GRID_HEADER_HEIGHT = 45;
export const TABLE_DIVIDER_WIDTH = 0.5;
